import * as React from "react";

const TicketSvg = ({ className }: { className?: string }) => (
  <svg
    className={`svg {className}`}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.74693 7.64502L4.41571 11.2885C4.36665 11.8281 4.34192 12.1001 4.38682 12.3584C4.42695 12.5892 4.50708 12.8112 4.62398 13.0142C4.75532 13.2422 4.94945 13.4363 5.33549 13.8224L10.511 18.9979C11.298 19.7849 11.6918 20.1786 12.147 20.3265C12.5487 20.4571 12.9821 20.4573 13.3837 20.3268C13.8404 20.1785 14.2372 19.7821 15.0293 18.9901L18.9891 15.0303C19.7811 14.2382 20.1765 13.8424 20.3248 13.3857C20.4553 12.9841 20.4546 12.5511 20.324 12.1495C20.1757 11.6928 19.7809 11.297 18.9889 10.505L13.8261 5.34229C13.4366 4.95272 13.2417 4.75792 13.0127 4.62598C12.8097 4.50908 12.5876 4.4286 12.3569 4.38848C12.0965 4.3432 11.822 4.36809 11.2733 4.41797L7.64351 4.74796C6.69875 4.83384 6.22608 4.87698 5.8564 5.08255C5.53048 5.26379 5.26179 5.53248 5.08055 5.8584C4.876 6.22623 4.83334 6.69555 4.74831 7.63092L4.74693 7.64502Z"
      stroke="white"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M9.71161 9.71297C10.1021 9.32244 10.1021 8.68928 9.71161 8.29876C9.32109 7.90823 8.68747 7.90823 8.29695 8.29876C7.90642 8.68928 7.90605 9.32229 8.29657 9.71282C8.6871 10.1033 9.32109 10.1035 9.71161 9.71297Z"
      stroke="white"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export default TicketSvg;
